<dialog-gala (clickClose)="hideModal()">
    <span gala-dialog-titre>{{titre}}</span>
    @if (idUtil) {
    <div>
        <table class="table table-striped">
            <thead>
                <tr>
                    @for (head of headElements; track head) {
                    <th (click)="sortBy(head.tri)" [ngClass]="(head.sortable)?'cursor-hand':'cursor-arrow'">
                        {{head.libelle}}&nbsp;@if (head.sortable) {
                        <cp-icon-sort [col]="sColTri === head.tri" [boo]=booAscendant />
                        }
                    </th>
                    }
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            @for (listesync of listeElementsAff; track listesync) {
            <tbody>
                <tr>
                    <td>{{ listesync.DEBSYNC | dateTimeFormat }}</td>
                    <td>{{ listesync.FINSYNC | dateTimeFormat }}</td>
                    <td>{{ listesync.VERSION }}</td>
                    <td>{{ listesync.VSYSTEME }}</td>
                    <td>
                        <sync-icon-echange [synchro]="listesync" />
                    </td>
                    <td>
                        <cp-icon-sync [statut]="listesync.SYNCHOK" />
                    <td>
                    <td>
                        <gala-btn-search [disabled]="listesync.CLIENTS[0]?.MODULES[0]?.MODULE?.CODE==='BGE'"
                            (click)="showDetails(listesync)" />
                    </td>
                </tr>
            </tbody>
            }
        </table>
        <paginator />
    </div>
    }
    <div gala-dialog-actions>
        <button mat-stroked-button color="accent" (click)="hideModal()">{{lgTrad.RETOUR}}</button>
    </div>
</dialog-gala>